<template>
  <div>
    <Modal
      :title="$t('global.verify-billing-tax')"
      @close="close"
      @confirm="confirm"
      :hide-footer="true"
      size="large"
    >
      <template #body>
        <div class="mb-3 text-center font-weight-bold text-primary">
          {{ $t("global.verify-billing-tax-message") }}
        </div>
        <Card :title="$t('global.billing-information')">
          <LoadingState v-if="billingAddressStatus.isLoading" />
          <template v-else-if="billingAddressStatus.isLoaded">
            <div v-if="billingAddress">
              <CardBlockList
                :title="`${billingAddress.firstName} ${billingAddress.lastName}`"
                :list="[
                  { item: billingAddress.email },
                  { item: billingAddress.address1 },
                  { item: billingAddress.address2 },
                  {
                    item: `${billingAddress.city}, ${billingAddress.state} ${billingAddress.zip}`,
                  },
                  { item: billingAddress.country },
                ]"
                :noBorder="true"
              />
              <hr class="mb-0" />
              <CardListContent
                v-if="client.allowTaxExemption"
                :list="[
                  {
                    label: `${$t('global.tax-exemption-number')}`,
                    content:
                      client.taxExemptNumber.length > 1
                        ? client.taxExemptNumber
                        : `${$t('global.na')}`,
                  },
                ]"
              />
            </div>

            <EmptyState v-else :message="$t('global.no-billing-address')" image="address" />
          </template>
          <ErrorState v-else />
        </Card>
        <div class="form-buttons">
          <Btn variant="light" type="button" @click="remindMeLater" class="float-left">
            {{ $t("global.remind-me-later") }}
          </Btn>
          <router-link :to="{ name: 'payment-info' }" class="button-router-link">
            <Btn variant="primaryOutline" type="button" @click="update" class="mr-2">
              {{ $t("global.verify-billing-tax-update") }}
            </Btn>
          </router-link>
          <Btn variant="primary" type="button" @click="confirm">
            {{ $t("global.verify-billing-tax-looks-good") }}
          </Btn>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { complete, postpone } from "@/utils/verifyBillingTaxModal";
import { computed, onMounted } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import Card from "@/components/display/Card";
import CardBlockList from "@/components/display/card-sub-components/CardBlockList";
import CardListContent from "@/components/display/card-sub-components/CardListContent";
import EmptyState from "@/components/display/empty-state/EmptyState";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import Modal from "@/components/display/Modal";
import store from "@/store";

export default {
  name: "VerifyBillingTaxModal",
  components: {
    Btn,
    Card,
    CardBlockList,
    CardListContent,
    EmptyState,
    ErrorState,
    LoadingState,
    Modal,
  },
  setup(props, { emit, root }) {
    const billingAddress = computed(() => store.getters["addresses/getBillingAddress"]);
    const billingAddressStatus = computed(() => store.state.addresses.status);
    const client = computed(() => store.getters["auth/getClient"]);
    const close = () => {
      emit("close");
    };
    const confirm = () => {
      complete(client.value);
      emit("confirm");
    };

    const remindMeLater = () => {
      postpone(client.value);
      emit("close");
    };

    const update = () => {
      complete(client.value);
      emit("close");
      root.$router.push({ name: "tax" });
    };

    onMounted(() => {
      store.dispatch("addresses/getList");
    });

    return {
      remindMeLater,
      update,
      billingAddress,
      billingAddressStatus,
      client,
      close,
      confirm,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
